import React from 'react';
import { Button } from '@heroui/react';
import { Search, GraduationCap } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

interface CoursesEmptyStateProps {
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

const CoursesEmptyState: React.FC<CoursesEmptyStateProps> = ({ hasActiveFilters, onClearFilters }) => {
  const { t } = useTranslation('courses');
  const stateKey = hasActiveFilters ? 'withFilters' : 'withoutFilters';

  return (
    <div className="relative overflow-hidden bg-white/60 dark:bg-gray-900/60 backdrop-blur-xl rounded-3xl border border-gray-200/50 dark:border-gray-800/50 p-16 text-center shadow-xl">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-purple-500/5" />
      <div className="relative">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-indigo-100 to-purple-100 dark:from-indigo-950 dark:to-purple-950 mb-6">
          {hasActiveFilters ? (
            <Search className="w-10 h-10 text-indigo-600 dark:text-indigo-400" />
          ) : (
            <GraduationCap className="w-10 h-10 text-indigo-600 dark:text-indigo-400" />
          )}
        </div>
        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
          {t(`states.empty.${stateKey}.title`)}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto">
          {t(`states.empty.${stateKey}.message`)}
        </p>
        {hasActiveFilters && (
          <Button
            color="primary"
            variant="solid"
            className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            onPress={onClearFilters}
          >
            {t(`states.empty.${stateKey}.action`)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CoursesEmptyState;

